webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        loadedSneakers: [],
        loadedBrands: [],
        user: null,
        loading: false,
        authError: null
    },
    mutations: {
        addSneakerToWishlist: function addSneakerToWishlist(state, payload) {
            var wishlist = state.user.wishlist;
            if (wishlist.findIndex(function (sneaker) {
                return sneaker.slug === payload.sneaker.slug;
            }) >= 0) {
                return;
            }
            state.user.wishlist.push(payload.sneaker);
        },
        removeSneakerFromWishlist: function removeSneakerFromWishlist(state, payload) {
            var wishlist = state.user.wishlist;
            wishlist.splice(wishlist.findIndex(function (sneaker) {
                return sneaker.slug === payload.slug;
            }), 1);
        },
        addSneakerToCollection: function addSneakerToCollection(state, payload) {
            var collection = state.user.collection;
            if (collection.findIndex(function (sneaker) {
                return sneaker.slug === payload.sneaker.slug;
            }) >= 0) {
                return;
            }
            state.user.collection.push(payload.sneaker);
        },
        removeSneakerFromCollection: function removeSneakerFromCollection(state, payload) {
            var collection = state.user.collection;
            collection.splice(collection.findIndex(function (sneaker) {
                return sneaker.slug === payload.slug;
            }), 1);
        },
        setLoadedBrands: function setLoadedBrands(state, payload) {
            state.loadedBrands = payload;
        },
        setLoadedSneakers: function setLoadedSneakers(state, payload) {
            state.loadedSneakers = payload;
        },
        setUser: function setUser(state, payload) {
            state.user = payload;
        },
        setLoading: function setLoading(state, payload) {
            state.loading = payload;
        },
        setError: function setError(state, payload) {
            state.error = payload;
        },
        clearError: function clearError(state) {
            state.error = null;
        }
    },
    actions: {
        addSneakerToWishlist: function addSneakerToWishlist(_ref, payload) {
            var commit = _ref.commit,
                getters = _ref.getters;

            var user = getters.user;
            var wishlist = getters.user.wishlist;
            if (wishlist.findIndex(function (sneaker) {
                return sneaker.slug === payload.slug;
            }) >= 0) {
                return;
            }
            __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + user.id + '/wishlist').child(payload.slug).set(payload).then(function (data) {
                commit('addSneakerToWishlist', { sneaker: payload });
            }).catch(function (error) {
                console.log(error);
            });
        },
        removeSneakerFromWishlist: function removeSneakerFromWishlist(_ref2, payload) {
            var commit = _ref2.commit,
                getters = _ref2.getters;

            var user = getters.user;
            __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + user.id + '/wishlist').child(payload.slug).remove().then(function () {
                commit('removeSneakerFromWishlist', payload);
            }).catch(function (error) {
                console.log(error);
            });
        },
        addSneakerToCollection: function addSneakerToCollection(_ref3, payload) {
            var commit = _ref3.commit,
                getters = _ref3.getters;

            var user = getters.user;
            var collection = getters.user.collection;
            if (collection.findIndex(function (sneaker) {
                return sneaker.slug === payload.slug;
            }) >= 0) {
                return;
            }
            __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + user.id + '/collection').child(payload.slug).set(payload).then(function (data) {
                commit('addSneakerToCollection', { sneaker: payload });
            }).catch(function (error) {
                console.log(error);
            });
        },
        removeSneakerFromCollection: function removeSneakerFromCollection(_ref4, payload) {
            var commit = _ref4.commit,
                getters = _ref4.getters;

            var user = getters.user;
            __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + user.id + '/collection').child(payload.slug).remove().then(function () {
                commit('removeSneakerFromCollection', payload);
            }).catch(function (error) {
                console.log(error);
            });
        },
        loadSneakers: function loadSneakers(_ref5) {
            var commit = _ref5.commit;

            __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('sneakers').orderByChild('release_date').on('value', function (data) {
                var sneakers = [];
                var obj = data.val();
                for (var key in obj) {
                    sneakers.push({
                        brand: obj[key].brand,
                        description: obj[key].description || "",
                        image_url: obj[key].image_url,
                        model_name: obj[key].model_name,
                        original_price: obj[key].original_price,
                        release_date: obj[key].release_date,
                        release_date_pretty: obj[key].release_date_pretty,
                        slug: obj[key].slug
                    });
                }
                function compare(a, b) {
                    if (a.release_date < b.release_date && a.image_url != "") return 1;
                    if (a.release_date > b.release_date && a.image_url != "") return -1;
                    return 0;
                }
                sneakers.sort(compare);
                commit('setLoadedSneakers', sneakers);
            });
        },
        loadBrands: function loadBrands(_ref6) {
            var commit = _ref6.commit;

            __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('brands').orderByChild('release_date').on('value', function (data) {
                var brands = [];
                var obj = data.val();
                for (var key in obj) {
                    brands.push({
                        id: key,
                        name: obj[key].name,
                        releases_count: obj[key].releases_count,
                        hero_image_url: obj[key].hero_image_url
                    });
                }
                commit('setLoadedBrands', brands);
            });
        },
        signUserUp: function signUserUp(_ref7, payload) {
            var commit = _ref7.commit;

            commit('setLoading', true);
            commit('clearError');
            __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
                commit('setLoading', false);
                var newUser = {
                    id: user.uid,
                    wishlist: [],
                    collection: []
                };
                commit('setUser', newUser);
            }).catch(function (error) {
                commit('setLoading', false);
                commit('setError', error);
                console.log(error);
            });
        },
        signUserIn: function signUserIn(_ref8, payload) {
            var commit = _ref8.commit;

            commit('setLoading', true);
            commit('clearError');
            __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
                commit('setLoading', false);
                var newUser = {
                    id: user.uid,
                    wishlist: [],
                    collection: []
                };
                commit('setUser', newUser);
            }).catch(function (error) {
                commit('setLoading', false);
                commit('setError', error);
                console.log(error);
            });
        },
        autoSignIn: function autoSignIn(_ref9, payload) {
            var commit = _ref9.commit;

            commit('setUser', { id: payload.uid, wishlist: [], collection: [] });
        },
        fetchUserData: function fetchUserData(_ref10) {
            var commit = _ref10.commit,
                getters = _ref10.getters;

            var wishlist = [];
            var collection = [];
            __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + getters.user.id + '/wishlist').once('value').then(function (data) {
                var obj = data.val();
                for (var key in obj) {
                    wishlist.push(obj[key]);
                }
            }).catch(function (error) {
                console.log(error);
            });
            __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + getters.user.id + '/collection').once('value').then(function (data) {
                var obj = data.val();
                for (var key in obj) {
                    collection.push(obj[key]);
                }
            }).catch(function (error) {
                console.log(error);
            });
            var updatedUser = {
                id: getters.user.id,
                wishlist: wishlist,
                collection: collection
            };
            commit('setUser', updatedUser);
        },
        logout: function logout(_ref11) {
            var commit = _ref11.commit;

            __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signOut();
            commit('setUser', null);
        }
    },
    getters: {
        loadedBrands: function loadedBrands(state) {
            return state.loadedBrands;
        },
        loadedBrand: function loadedBrand(state) {
            return function (brandId) {
                return state.loadedSneakers.filter(function (sneaker) {
                    return sneaker.brand === brandId;
                });
            };
        },
        loadedSneakers: function loadedSneakers(state) {
            return state.loadedSneakers;
        },
        loadedSneaker: function loadedSneaker(state) {
            return function (sneakerSlug) {
                return state.loadedSneakers.find(function (sneaker) {
                    return sneaker.slug === sneakerSlug;
                });
            };
        },
        user: function user(state) {
            return state.user;
        }
    }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Home__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Sneakers__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Sneakers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Sneakers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Brand__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Brand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Brand__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Sneaker__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Sneaker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Sneaker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Profile__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Collection__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Collection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_Collection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Stats__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Stats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_Stats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Wishlist__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Wishlist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Wishlist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Login__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_SignUp__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_SignUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_SignUp__);




















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{ path: '/', name: 'Home', component: __WEBPACK_IMPORTED_MODULE_4__pages_Home___default.a }, { path: '/sneakers', name: 'Sneakers', component: __WEBPACK_IMPORTED_MODULE_5__pages_Sneakers___default.a }, { path: '/sneakers/:brand', name: 'Brand', component: __WEBPACK_IMPORTED_MODULE_6__pages_Brand___default.a, props: true }, { path: '/sneakers/:brand/:slug', name: 'Sneaker', component: __WEBPACK_IMPORTED_MODULE_7__pages_Sneaker___default.a, props: true }, { path: '/profile', name: 'Profile', component: __WEBPACK_IMPORTED_MODULE_8__pages_Profile___default.a, meta: { requiresAuth: true } }, { path: '/collection', name: 'Collection', component: __WEBPACK_IMPORTED_MODULE_9__pages_Collection___default.a, meta: { requiresAuth: true } }, { path: '/wishlist', name: 'Wishlist', component: __WEBPACK_IMPORTED_MODULE_11__pages_Wishlist___default.a, meta: { requiresAuth: true } }, { path: '/stats', name: 'Stats', component: __WEBPACK_IMPORTED_MODULE_10__pages_Stats___default.a, meta: { requiresAuth: true } }, { path: '/login', name: 'Login', component: __WEBPACK_IMPORTED_MODULE_12__pages_Login___default.a }, { path: '/signup', name: 'SignUp', component: __WEBPACK_IMPORTED_MODULE_13__pages_SignUp___default.a }, { path: '*', redirect: '/' }]
});

router.beforeEach(function (to, from, next) {
    var currentUser = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].getters.user;
    var requiresAuth = to.matched.some(function (record) {
        return record.meta.requiresAuth;
    });

    if (requiresAuth && !currentUser) {
        next('login');
    } else {
        next();
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'App',
    data: function data() {
        return {};
    }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'main-menu',
    data: function data() {
        return {};
    },

    methods: {
        onLogout: function onLogout() {
            this.$store.dispatch('logout');
        }
    },
    computed: {
        userIsAuthenticated: function userIsAuthenticated() {
            return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
        }
    }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'brand',
    props: ['brand'],
    data: function data() {
        return {
            loadedSneakersCount: 12
        };
    },

    computed: {
        brands: function brands() {
            var _this = this;

            return this.$store.getters.loadedBrands.filter(function (brand) {
                return brand.name === _this.brand;
            });
        },
        sneakers: function sneakers() {
            return this.$store.getters.loadedBrand(this.brand).slice(0, this.loadedSneakersCount);
        }
    },
    methods: {
        loadMoreSneakers: function loadMoreSneakers() {
            this.loadedSneakersCount += 12;
        }
    }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'collection',
    computed: {
        collection: function collection() {
            return this.$store.getters.user.collection;
        }
    }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'home',
    data: function data() {
        return {};
    },

    computed: {
        sneakers: function sneakers() {
            return this.$store.getters.loadedSneakers.slice(0, 6);
        },
        brands: function brands() {
            return this.$store.getters.loadedBrands.slice(0, 3);
        }
    }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',
    data: function data() {
        return {
            email: '',
            password: ''
        };
    },

    computed: {
        user: function user() {
            return this.$store.getters.user;
        }
    },
    watch: {
        user: function user(value) {
            if (value !== null && value !== undefined) {
                this.$router.push('/');
            }
        }
    },
    methods: {
        onSignIn: function onSignIn() {
            this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
        }
    }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'profile',
    data: function data() {
        return {
            user: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser
        };
    },

    methods: {}
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'signUp',
    data: function data() {
        return {
            email: '',
            password: ''
        };
    },

    computed: {
        user: function user() {
            return this.$store.getters.user;
        }
    },
    watch: {
        user: function user(value) {
            if (value !== null && value !== undefined) {
                this.$router.push('/');
            }
        }
    },
    methods: {
        onSignUp: function onSignUp() {
            this.$store.dispatch('signUserUp', { email: this.email, password: this.password });
        }
    }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sneaker',
    props: ['slug'],
    data: function data() {
        return {};
    },

    computed: {
        sneaker: function sneaker() {
            return this.$store.getters.loadedSneaker(this.slug);
        },
        user: function user() {
            return this.$store.getters.user;
        }
    },
    methods: {
        addSneakerToWishlist: function addSneakerToWishlist() {
            this.$store.dispatch('addSneakerToWishlist', this.sneaker);
        },
        removeSneakerFromWishlist: function removeSneakerFromWishlist() {
            this.$store.dispatch('removeSneakerFromWishlist', this.sneaker);
        },
        addSneakerToCollection: function addSneakerToCollection() {
            this.$store.dispatch('addSneakerToCollection', this.sneaker);
        },
        removeSneakerFromCollection: function removeSneakerFromCollection() {
            this.$store.dispatch('removeSneakerFromCollection', this.sneaker);
        }
    },
    filters: {
        price: function price(value) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value) ? "€" + value : value;
        }
    }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Brands',
    data: function data() {
        return {
            searchQuery: "",
            selected: "",
            foundSneakers: 0
        };
    },

    watch: {
        searchQuery: function searchQuery() {
            this.selected = this.filteredSneaker[0];
        }
    },
    computed: {
        brands: function brands() {
            return this.$store.getters.loadedBrands;
        },
        filteredSneaker: function filteredSneaker() {
            if (this.searchQuery === "") return;
            var query = this.searchQuery.toLowerCase().split(" ");
            return this.$store.getters.loadedSneakers.filter(function (sneaker) {
                return query.every(function (value) {
                    return sneaker.model_name.toLowerCase().indexOf(value) >= 0 && sneaker.image_url !== "";
                });
            }).slice(0, 10);
        },
        searchResults: function searchResults() {
            if (this.filteredSneaker == undefined) {
                return "Search for your favorite sneakers here.";
            } else if (this.filteredSneaker.length > 10) {
                return "We found more than 10 sneakers, if you didn't find what you were looking for, try more specific search criteria.";
            } else if (this.filteredSneaker.length == 0) {
                return "We could not find any sneakers matching these criteria.";
            } else if (this.filteredSneaker.length == 1) {
                return "We found " + this.filteredSneaker.length + " sneaker matching your criteria.";
            } else {
                return "We found " + this.filteredSneaker.length + " sneakers matching your criteria.";
            }
        }
    },
    methods: {
        goToSneaker: function goToSneaker() {
            var brand = this.selected.brand;
            var slug = this.selected.slug;
            this.$router.push("/sneakers/" + brand + "/" + slug);
        }
    }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'stats',
    data: function data() {
        return {};
    },

    methods: {}
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'wishlist',
    computed: {
        wishlist: function wishlist() {
            return this.$store.getters.user.wishlist;
        }
    }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MainMenu__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MainMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_MainMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_simple_spinner__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_simple_spinner__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuefire___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('main-menu', __WEBPACK_IMPORTED_MODULE_6__components_MainMenu___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('spinner', __WEBPACK_IMPORTED_MODULE_7_vue_simple_spinner___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__webpack_require__(13);
__webpack_require__(14);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_2_firebase__["initializeApp"]({
            apiKey: "AIzaSyDwzTXaBJxNudaPHLgfseR2sybXoTWVth0",
            authDomain: "mysneakercollection.firebaseapp.com",
            databaseURL: "https://mysneakercollection.firebaseio.com",
            projectId: "mysneakercollection",
            storageBucket: "",
            messagingSenderId: "514837027216"
        });
        __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().onAuthStateChanged(function (user) {
            if (user) {
                _this.$store.dispatch('autoSignIn', user);
                _this.$store.dispatch('fetchUserData');
            }
        });
        this.$store.dispatch('loadSneakers');
        this.$store.dispatch('loadBrands');
    }
});

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(69),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(71),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(72),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3eb0049f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(73),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(70),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(46)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(68),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(74),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9a37d99e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(76),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a56c17dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(77),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(79),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-x grid-margin-x"
  }, [_c('div', {
    staticClass: "small-10 small-offset-1 medium-6 medium-offset-3 cell"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSignUp($event)
      }
    }
  }, [_c('h3', [_vm._v("Sign up")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button expanded"
  }, [_vm._v("Sign up")]), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log in to your account")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "brand-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.brands[0].hero_image_url
    }
  })]), _vm._v(" "), (_vm.sneakers != null) ? _c('div', {
    staticClass: "grid-x grid-margin-x"
  }, [_vm._l((_vm.sneakers), function(sneaker) {
    return _c('div', {
      staticClass: "small-12 medium-6 large-4 cell"
    }, [_c('router-link', {
      staticClass: "card",
      attrs: {
        "to": {
          path: ("/sneakers/" + (sneaker.brand) + "/" + (sneaker.slug))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": sneaker.image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-section"
    }, [_c('p', {
      staticClass: "lead"
    }, [_vm._v(_vm._s(sneaker.brand))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(sneaker.model_name))]), _vm._v(" "), _c('div', {
      staticClass: "grid-x card-info"
    }, [_c('div', {
      staticClass: "small-5 small-offset-1"
    }, [_c('p', [_vm._v(_vm._s(sneaker.release_date_pretty))])]), _vm._v(" "), _c('div', {
      staticClass: "small-5 small-offset-1"
    }, [(sneaker.original_price != 'TBA') ? _c('p', [_vm._v("€" + _vm._s(sneaker.original_price))]) : _c('p', [_vm._v(_vm._s(sneaker.original_price))])])])])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.loadMoreSneakers()
      }
    }
  }, [_vm._v("Load more sneakers")])])], 2) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-12 cell"
  }, [_c('h1', [_vm._v("Your profile")]), _vm._v(" "), _c('p', [_vm._v("You're logged in as " + _vm._s(_vm.user.email) + ".")])])])])])
},staticRenderFns: []}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [(_vm.collection != null) ? _c('div', {
    staticClass: "grid-container"
  }, [_vm._m(0, false, false), _vm._v(" "), (_vm.collection.length == 0) ? _c('div', {
    staticClass: "grid-x"
  }, [_vm._m(1, false, false)]) : _c('div', {
    staticClass: "grid-x grid-margin-x"
  }, _vm._l((_vm.collection), function(sneaker) {
    return _c('div', {
      staticClass: "small-12 medium-6 large-4 cell"
    }, [(sneaker != null) ? _c('router-link', {
      staticClass: "card",
      attrs: {
        "to": {
          path: ("/sneakers/" + (sneaker.brand) + "/" + (sneaker.slug))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": sneaker.image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-section"
    }, [_c('p', {
      staticClass: "lead"
    }, [_vm._v(_vm._s(sneaker.brand))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(sneaker.model_name))]), _vm._v(" "), _c('div', {
      staticClass: "grid-x card-info"
    }, [_c('div', {
      staticClass: "small-5 small-offset-1"
    }, [_c('p', [_vm._v(_vm._s(sneaker.release_date_pretty))])]), _vm._v(" "), _c('div', {
      staticClass: "small-5 small-offset-1"
    }, [(sneaker.original_price != 'TBA') ? _c('p', [_vm._v("€" + _vm._s(sneaker.original_price))]) : _c('p', [_vm._v(_vm._s(sneaker.original_price))])])])])]) : _vm._e()], 1)
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('h1', [_vm._v("Your collection")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 cell"
  }, [_c('p', [_vm._v("No sneakers in collection.")])])
}]}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-x grid-margin-x"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._l((_vm.sneakers), function(sneaker) {
    return _c('div', {
      staticClass: "small-12 medium-6 large-4 cell"
    }, [_c('router-link', {
      staticClass: "card",
      attrs: {
        "to": {
          path: ("/sneakers/" + (sneaker.brand) + "/" + (sneaker.slug))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": sneaker.image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-section"
    }, [_c('p', {
      staticClass: "lead"
    }, [_vm._v(_vm._s(sneaker.brand))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(sneaker.model_name))])])])], 1)
  }), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('div', {
      staticClass: "small-12 medium-6 large-4 cell sneaker-card"
    }, [_c('router-link', {
      staticClass: "card",
      attrs: {
        "to": {
          path: ("/sneakers/" + (brand.name))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": brand.hero_image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-section"
    }, [_c('p', {
      staticClass: "lead"
    }, [_vm._v(_vm._s(brand.name))])])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('router-link', {
    staticClass: "button primary",
    attrs: {
      "to": {
        path: "/sneakers"
      }
    }
  }, [_vm._v("Go to all brands")])], 1)], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-image"
  }, [_c('div', {
    staticClass: "header-overlay"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/flightclubny.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home-text"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("My SNKR Collection")]), _vm._v(" "), _c('h2', {
    staticClass: "tagline"
  }, [_vm._v("your collection, everywhere")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('h2', [_vm._v("Latest releases")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('h2', [_vm._v("Popular brands")])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-x grid-margin-x"
  }, [_c('div', {
    staticClass: "small-10 small-offset-1 medium-6 medium-offset-3 cell"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSignIn($event)
      }
    }
  }, [_c('h3', [_vm._v("Log in")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button expanded"
  }, [_vm._v("Log in")]), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Create account")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-12 medium-8 medium-offset-2 large-6 large-offset-3 cell"
  }, [(_vm.sneaker != null) ? _c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": _vm.sneaker.image_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-section"
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.sneaker.brand))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sneaker.model_name))]), _vm._v(" "), _c('div', {
    staticClass: "grid-x card-info"
  }, [_c('div', {
    staticClass: "small-5 small-offset-1"
  }, [_c('p', [_vm._v(_vm._s(_vm.sneaker.release_date_pretty))])]), _vm._v(" "), _c('div', {
    staticClass: "small-5 small-offset-1"
  }, [_c('p', [_vm._v(_vm._s(_vm._f("price")(_vm.sneaker.original_price)))])])]), _vm._v(" "), (_vm.user) ? _c('div', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.addSneakerToWishlist()
      }
    }
  }, [_vm._v("Add to wishlist")]), _vm._v(" "), _c('button', {
    staticClass: "button alert",
    on: {
      "click": function($event) {
        _vm.removeSneakerFromWishlist()
      }
    }
  }, [_vm._v("Remove from wishlist")])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.addSneakerToCollection()
      }
    }
  }, [_vm._v("Add to collection")]), _vm._v(" "), _c('button', {
    staticClass: "button alert",
    on: {
      "click": function($event) {
        _vm.removeSneakerFromCollection()
      }
    }
  }, [_vm._v("Remove from collection")])]) : _c('div', [_c('p', [_vm._v("Please \n                                "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("log in")]), _vm._v(" or\n                                "), _c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("sign up")]), _vm._v(" to add to wishlist or collection.\n                            ")], 1)])])]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "top-bar"
  }, [_c('div', {
    staticClass: "top-bar-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("My SNKR Collection")])], 1), _vm._v(" "), _c('div', {
    staticClass: "top-bar-right"
  }, [_c('ul', {
    staticClass: "menu vertical medium-horizontal"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/sneakers'
      }
    }
  }, [_vm._v("Sneakers")])], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/collection'
      }
    }
  }, [_vm._v("Collection")])], 1) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/wishlist'
      }
    }
  }, [_vm._v("Wishlist")])], 1) : _vm._e(), _vm._v(" "), _c('li', [(_vm.userIsAuthenticated) ? _c('a', {
    staticClass: "logout",
    on: {
      "click": _vm.onLogout
    }
  }, [_vm._v("Log out")]) : _c('router-link', {
    staticClass: "login",
    attrs: {
      "to": {
        path: '/login'
      }
    }
  }, [_vm._v("Log in")])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-x grid-margin-x"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "small-12 cell"
  }, [_c('div', {
    staticClass: "callout large"
  }, [_c('h5', [_vm._v("Looking for a sneaker?")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.searchResults))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    attrs: {
      "type": "text",
      "list": "sneakers",
      "required": ""
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filteredSneaker != undefined) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.filteredSneaker), function(sneaker) {
    return _c('option', {
      domProps: {
        "value": sneaker
      }
    }, [_vm._v(_vm._s(sneaker.model_name))])
  })) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.goToSneaker()
      }
    }
  }, [_vm._v("Go to sneaker")])])])]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('div', {
      staticClass: "small-12 medium-6 large-4 cell"
    }, [_c('router-link', {
      staticClass: "card",
      attrs: {
        "to": {
          path: ("/sneakers/" + (brand.name))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": brand.hero_image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-section"
    }, [_c('p', {
      staticClass: "lead"
    }, [_vm._v(_vm._s(brand.name))])])])], 1)
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('h1', [_vm._v("Sneakers")])])
}]}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-12 cell"
  }, [_c('h1', [_vm._v("Sneaker stats")])])])])])
}]}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main-menu'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [(_vm.wishlist != null) ? _c('div', {
    staticClass: "grid-container"
  }, [_vm._m(0, false, false), _vm._v(" "), (_vm.wishlist.length == 0) ? _c('div', {
    staticClass: "grid-x"
  }, [_vm._m(1, false, false)]) : _c('div', {
    staticClass: "grid-x grid-margin-x"
  }, _vm._l((_vm.wishlist), function(sneaker) {
    return _c('div', {
      staticClass: "small-12 medium-6 large-4 cell"
    }, [(sneaker != null) ? _c('router-link', {
      staticClass: "card",
      attrs: {
        "to": {
          path: ("/sneakers/" + (sneaker.brand) + "/" + (sneaker.slug))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": sneaker.image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-section"
    }, [_c('p', {
      staticClass: "lead"
    }, [_vm._v(_vm._s(sneaker.brand))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(sneaker.model_name))]), _vm._v(" "), _c('div', {
      staticClass: "grid-x card-info"
    }, [_c('div', {
      staticClass: "small-5 small-offset-1"
    }, [_c('p', [_vm._v(_vm._s(sneaker.release_date_pretty))])]), _vm._v(" "), _c('div', {
      staticClass: "small-5 small-offset-1"
    }, [(sneaker.original_price != 'TBA') ? _c('p', [_vm._v("€" + _vm._s(sneaker.original_price))]) : _c('p', [_vm._v(_vm._s(sneaker.original_price))])])])])]) : _vm._e()], 1)
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('h1', [_vm._v("Your wishlist")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 cell"
  }, [_c('p', [_vm._v("No sneakers in wishlist.")])])
}]}

/***/ })
],[31]);


// WEBPACK FOOTER //
// static/js/app.6812f05a584ae8f58287.js